export function areAllNumbers(...args) {
   return args.every((arg) => !isNaN(arg) && !isNaN(parseFloat(arg)));
}

export function subtractNumbers(a, b) {
   if (!areAllNumbers(a, b)) {
      throw new Error("Both arguments must be numbers or numeric strings.");
   }
   return Math.abs(parseFloat(a)) - Math.abs(parseFloat(b));
}

export function addNumbers(...args) {
   if (!areAllNumbers(...args)) {
      throw new Error("All arguments must be numbers or numeric strings.");
   }
   return args.reduce((sum, num) => sum + parseFloat(num), 0);
}

export function calculateDetentionRate(hours) {
   if (!areAllNumbers(hours)) {
      throw new Error("Hours must be a number or numeric string.");
   }
   const extraHours = parseFloat(hours) - 24;
   if (extraHours <= 0) return 0;
   const days = Math.ceil(extraHours / 24);
   return days * 2000;
}
